import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreUserTaxInfoModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DeactivateVatNumberModalComponent } from './deactivate-vat-number-modal.component';

@NgModule({
  imports: [CommonModule, DatastoreUserTaxInfoModule, UiModule, TrackingModule],
  declarations: [DeactivateVatNumberModalComponent],
})
export class DeactivateVatNumberModalModule {}
